import { z } from 'zod'
import { zId, zIdNullable } from '../common'
import { zAdminRole } from '../enums'

export const zAdmin = z.object({
  id: zId,
  email: z.string(),
  role: zAdminRole,
  // null for a super_admin (sees all tenants).
  tenantId: zIdNullable,
})
export type Admin = z.infer<typeof zAdmin>

// POST /session → { token, admin }. Token is a 30-day Bearer. There is no
// "me" endpoint: the admin object is persisted alongside the token and reread
// at boot.
export const zSession = z.object({
  token: z.string(),
  admin: zAdmin,
})
export type Session = z.infer<typeof zSession>
